import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const YIL = new Date().getFullYear();
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

export default function MakineVarligi() {
  const [kayitlar,       setKayitlar]       = useState<any[]>([]);
  const [isletmeler,     setIsletmeler]     = useState<any[]>([]);
  const [makineTanimlar,   setMakineTanimlar]   = useState<any[]>([]);
  const [mulkiyetTanimlar, setMulkiyetTanimlar] = useState<any[]>([]);
  const [modalAcik,        setModalAcik]        = useState(false);
  const [form,             setForm]             = useState<any>({ isletme_id: '', yil: YIL, ay: 12, makine_turu: '', adet: 0, toplam_guc_kw: 0, mulkiyet_kod: 'V.2.2.1', marka_model: '', dugum_id: null });
  const [filtre,         setFiltre]         = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || ''
    };
  })());
  const [hata,           setHata]           = useState('');
  const [yukleniyor,     setYukleniyor]     = useState(false);

  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = user?.rol && ['super_admin','gm_yonetici','gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin','gm_yonetici'].includes(user.rol);

  const [kiralikGoster, setKiralikGoster] = useState(false);

  const mulkAd = (kod: string) => mulkiyetTanimlar.find(t => t.kod === kod)?.ad || kod;
  const mulkBadge = (kod: string) => kod === 'V.2.2.1' ? 'aktif' : 'pasif';

  useEffect(() => {
    if (!isGM && user?.isletme_id) setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
    axios.get(`${API}/api/agac/tanimlar/makine`, { headers: headers() }).then(r => setMakineTanimlar(r.data)).catch(() => setMakineTanimlar([]));
    axios.get(`${API}/api/tanimlar2/liste`, { headers: headers(), params: { ust: 'V.2.2', sadece_yaprak: true } }).then(r => setMulkiyetTanimlar(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const p: any = { yil: filtre.yil };
    if (filtre.isletme_id) p.isletme_id = filtre.isletme_id;
    if (filtre.ay) p.ay = Number(filtre.ay);
    axios.get(`${API}/api/varlik/makine-tekil`, { headers: headers(), params: p }).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      await axios.post(`${API}/api/varlik/makine-tekil`, { ...form, isletme_id: Number(form.isletme_id) }, { headers: headers() });
      yukle(); setModalAcik(false);
      setForm({ isletme_id: isGM ? '' : user?.isletme_id, yil: YIL, makine_turu: '', adet: 0, toplam_guc_kw: 0, mulkiyet_kod: 'V.2.2.1', marka_model: '', dugum_id: null });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Silmek istiyor musunuz?')) return;
    try { await axios.delete(`${API}/api/varlik/makine-tekil/${id}`, { headers: headers() }); yukle(); } catch {}
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) await axios.delete(`${API}/api/varlik/makine-tekil/${k.id}`, { headers: headers() });
    yukle();
  };

  const n = (v: any) => Number(v || 0).toLocaleString('tr-TR');

  const makineColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'makine_turu', label: 'Makine Türü', sortable: true, filterable: true, render: (k: any) => <strong>{k.makine_turu}</strong>, filterValue: (k: any) => k.makine_turu || '' },
    { key: 'adet', label: 'Adet', sortable: true, render: (k: any) => n(k.adet), sortValue: (k: any) => Number(k.adet || 0) },
    { key: 'toplam_guc_kw', label: 'Güç (KW)', sortable: true, render: (k: any) => k.toplam_guc_kw ? n(k.toplam_guc_kw) : '-', sortValue: (k: any) => Number(k.toplam_guc_kw || 0) },
    { key: 'mulkiyet_kod', label: 'Mülkiyet', filterable: true, render: (k: any) => <span className={`badge badge-${mulkBadge(k.mulkiyet_kod)}`}>{mulkAd(k.mulkiyet_kod)}</span>, filterValue: (k: any) => mulkAd(k.mulkiyet_kod) },
    { key: 'marka_model', label: 'Marka/Model', filterable: true, render: (k: any) => k.marka_model || '-', filterValue: (k: any) => k.marka_model || '' },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => { setForm({ ...k }); setHata(''); setModalAcik(true); }}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  // Özet hesapla (yüklü kayıtlardan)
  const ozet = React.useMemo(() => {
    const traktor = kayitlar.filter(k => k.makine_turu === 'Traktör');
    const traktorAdet = traktor.reduce((s, k) => s + (k.adet || 0), 0);
    const traktorKw   = traktor.reduce((s, k) => s + (k.toplam_guc_kw || 0), 0);
    // Traktör hariç makine türlerine göre toplam adet
    const turMap: Record<string, number> = {};
    kayitlar.filter(k => k.makine_turu !== 'Traktör').forEach(k => {
      turMap[k.makine_turu] = (turMap[k.makine_turu] || 0) + (k.adet || 0);
    });
    const topMakineler = Object.entries(turMap)
      .filter(([, adet]) => adet > 0)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 4);
    return { traktorAdet, traktorKw, topMakineler };
  }, [kayitlar]);

  const KART_IKONLAR: Record<string, string> = {
    'Biçerdöver':'🌾','Ekskavatör':'🚜','Loader':'🚛','Beko Kepçe':'🏗️',
    'Greyder':'🛣️','Dozer':'🚧','Forklift (Dizel)':'🏭','Teleskobik Forklift':'📦',
    'Silaj Makinesi':'🌿','Balya Makinesi':'🎯','Mini Yükleyici':'⚙️',
  };
  const ikon = (tur: string) => KART_IKONLAR[tur] || '🔧';

  return (
    <div>
      <div className="page-header">
        <h1>⚙️ Makine & Ekipman</h1>
        <p>İşletme bazında makine ve ekipman varlık verileri</p>
      </div>

      {kayitlar.length > 0 && (
        <div className="stats-grid" style={{ marginBottom: 16 }}>
          <div className="stat-card">
            <div className="stat-icon">🚜</div>
            <div><div className="stat-value">{n(ozet.traktorAdet)}</div><div className="stat-label">Traktör (adet)</div></div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">⚡</div>
            <div><div className="stat-value">{n(Math.round(ozet.traktorKw))}</div><div className="stat-label">Traktör Toplam Güç (KW)</div></div>
          </div>
          {ozet.topMakineler.map(([tur, adet]) => (
            <div className="stat-card" key={tur}>
              <div className="stat-icon">{ikon(tur)}</div>
              <div><div className="stat-value">{n(adet)}</div><div className="stat-label">{tur}</div></div>
            </div>
          ))}
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 120 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 210 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, cursor:'pointer', whiteSpace:'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <button className="btn btn-success" onClick={() => { setForm({ isletme_id: isGM ? '' : user?.isletme_id, yil: YIL, ay: 12, makine_turu: '', adet: 0, toplam_guc_kw: 0, mulkiyet_kod: 'V.2.2.1', marka_model: '', dugum_id: null }); setHata(''); setModalAcik(true); }}>+ Yeni Kayıt</button>
        </div>
        <DataTable columns={makineColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="makine-ekipman" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 520 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>⚙️ Makine Kayıt Girişi</h3><button className="modal-close" onClick={() => setModalAcik(false)}>×</button></div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-row">
                {isGM && (
                  <div className="form-group"><label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id} onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group"><label>Yıl *</label><input className="form-control" type="number" value={form.yil} onChange={e => setForm({ ...form, yil: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Ay *</label>
                  <select className="form-control" value={form.ay} onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Makine / Ekipman Türü *</label>
                <select className="form-control" value={form.makine_turu || ''} onChange={e => {
                  const sec = makineTanimlar.find((m: any) => m.ad === e.target.value);
                  setForm({ ...form, makine_turu: e.target.value, dugum_id: sec?.id });
                }}>
                  <option value="">Seçiniz</option>
                  {makineTanimlar.map((m: any) => <option key={m.id} value={m.ad}>{m.ad}</option>)}
                  <option value="Diğer">Diğer (Manuel Giriş)</option>
                </select>
                {form.makine_turu === 'Diğer' && (
                  <input className="form-control" style={{ marginTop: 6 }} placeholder="Makine türünü yazın..."
                    onChange={e => setForm({ ...form, makine_turu: e.target.value })} />
                )}
                <small style={{ color: '#888', fontSize: 11 }}>Listede yoksa "Diğer" seçip yazabilirsiniz.</small>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Adet *</label><input className="form-control" type="number" value={form.adet} onChange={e => setForm({ ...form, adet: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Mülkiyet</label>
                  <select className="form-control" value={form.mulkiyet_kod || 'V.2.2.1'} onChange={e => setForm({ ...form, mulkiyet_kod: e.target.value })}>
                    {mulkiyetTanimlar.map(t => <option key={t.kod} value={t.kod}>{t.ad}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Toplam Güç (KW) — Traktör için</label><input className="form-control" type="number" value={form.toplam_guc_kw} onChange={e => setForm({ ...form, toplam_guc_kw: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Marka / Model</label><input className="form-control" value={form.marka_model || ''} onChange={e => setForm({ ...form, marka_model: e.target.value })} /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
